import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useParams } from "react-router-dom";
import { LanguageProvider } from "./i18n/LanguageContext";
import { AuthProvider } from "./context/AuthContext";
import { QuoteProvider } from "./context/QuoteContext";
import { Toaster } from "./components/ui/sonner";
import ScrollToTop from "./components/ScrollToTop";
import Layout from "./layout/Layout";
import ProtectedRoute from "./components/ProtectedRoute";
import HomePage from "./pages/HomePage";
import ProductsPage from "./pages/ProductsPage";
import ProductDetailPage from "./pages/ProductDetailPage";
import CategoryPage from "./pages/CategoryPage";
import SubcategoryPage from "./pages/SubcategoryPage";
import DimensioneringPage from "./pages/DimensioneringPage";
import ExpansionCalculatorPage from "./pages/ExpansionCalculatorPage";
import DimensioneringHubPage from "./pages/DimensioneringHubPage";
import SpecialtankPage from "./pages/SpecialtankPage";
import JobsPage from "./pages/JobsPage";
import JobDetailPage from "./pages/JobDetailPage";
import AboutPage from "./pages/AboutPage";
import ContactPage from "./pages/ContactPage";
import LibraryPage from "./pages/LibraryPage";
import AdminPage from "./pages/AdminPage";
import LoginPage from "./pages/LoginPage";
import QuoteListPage from "./pages/QuoteListPage";
import QuickQuotePage from "./pages/QuickQuotePage";
import KnowledgeHubPage from "./pages/KnowledgeHubPage";
import KnowledgeArticlePage from "./pages/KnowledgeArticlePage";
import NotFoundPage from "./pages/NotFoundPage";

const RedirectWithId = ({ to }) => {
  const { id } = useParams();
  return <Navigate to={`${to}/${id}`} replace />;
};

function App() {
  return (
    <LanguageProvider>
      <AuthProvider>
        <QuoteProvider>
          <div className="App">
            <BrowserRouter>
              <ScrollToTop />
              <Layout>
                <Routes>
                  <Route path="/" element={<HomePage />} />
                  <Route path="/produkter" element={<ProductsPage />} />
                  <Route path="/produkter/kategori/:categorySlug/:subcategorySlug" element={<SubcategoryPage />} />
                  <Route path="/produkter/kategori/:categorySlug" element={<CategoryPage />} />
                  <Route path="/produkter/:id" element={<ProductDetailPage />} />
                  <Route path="/dimensionering" element={<DimensioneringHubPage />} />
                  <Route path="/dimensionering/ackumulatortank" element={<DimensioneringPage />} />
                  <Route path="/dimensionering/expansionskarl" element={<ExpansionCalculatorPage />} />
                  <Route path="/dimensionering/specialtank" element={<SpecialtankPage />} />
                  <Route path="/jobb" element={<JobsPage />} />
                  <Route path="/jobb/:id" element={<JobDetailPage />} />
                  <Route path="/bibliotek" element={<LibraryPage />} />
                  <Route path="/om-oss" element={<AboutPage />} />
                  <Route path="/kontakt" element={<ContactPage />} />
                  <Route path="/logga-in" element={<LoginPage />} />
                  <Route path="/offert" element={<QuoteListPage />} />
                  <Route path="/snabboffert" element={<QuickQuotePage />} />
                  <Route path="/kunskap" element={<KnowledgeHubPage />} />
                  <Route path="/kunskap/:slug" element={<KnowledgeArticlePage />} />
                  <Route path="/admin" element={
                    <ProtectedRoute>
                      <AdminPage />
                    </ProtectedRoute>
                  } />
                  {/* Redirects for old English URLs (avoid duplicate content) */}
                  <Route path="/products" element={<Navigate to="/produkter" replace />} />
                  <Route path="/products/:id" element={<RedirectWithId to="/produkter" />} />
                  <Route path="/jobs" element={<Navigate to="/jobb" replace />} />
                  <Route path="/jobs/:id" element={<RedirectWithId to="/jobb" />} />
                  <Route path="/about" element={<Navigate to="/om-oss" replace />} />
                  <Route path="/contact" element={<Navigate to="/kontakt" replace />} />
                  <Route path="/login" element={<Navigate to="/logga-in" replace />} />
                  <Route path="/quote" element={<Navigate to="/offert" replace />} />
                  {/* Catch-all 404 for unknown/old URLs (noindex so Google removes them) */}
                  <Route path="*" element={<NotFoundPage />} />
                </Routes>
              </Layout>
            </BrowserRouter>
            <Toaster 
              position="top-right"
              closeButton
              richColors
              duration={4000}
            />
          </div>
        </QuoteProvider>
      </AuthProvider>
    </LanguageProvider>
  );
}

export default App;
